import { useState } from "react";
import { toast } from "sonner";
import { marketingApi } from "@/lib/marketing";
import { copyToClipboard } from "./shared";

function downloadDataUrl(dataUrl, filename) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  a.click();
}

export default function QRPanel({ link }) {
  const [trackSeparately, setTrackSeparately] = useState(false);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const generate = async () => {
    setBusy(true);
    try {
      const res = await marketingApi.generateQr(link.link_id, trackSeparately);
      setResult(res);
      toast.success("QR generated");
    } catch (e) {
      toast.error(e.message || "QR generation failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="qr-panel">
      <label className="flex items-center gap-2 font-body text-sm text-ink">
        <input type="checkbox" checked={trackSeparately} onChange={(e) => setTrackSeparately(e.target.checked)} data-testid="qr-track-separately-toggle" />
        Track QR separately (creates a child link with its own slug)
      </label>
      <button type="button" onClick={generate} disabled={busy} data-testid="qr-generate-button"
        className="bg-ink text-paper py-2.5 px-5 font-body text-xs uppercase tracking-[0.14em] hover:bg-terracotta transition-colors disabled:opacity-50">
        {busy ? "Generating…" : "Generate QR"}
      </button>

      {result && (
        <div className="border border-ink/12 p-4 space-y-3" data-testid="qr-result">
          <img src={`data:image/png;base64,${result.png_base64}`} alt="QR code" className="w-40 h-40 border border-ink/10" data-testid="qr-preview-image" />
          <p className="font-body text-xs text-ink-soft break-all" data-testid="qr-target-url">{result.qr_target_url}</p>
          {result.child_link && (
            <p className="font-body text-xs text-terracotta" data-testid="qr-child-link-note">
              Encodes a NEW child link (parent_link_id: {result.child_link.metadata.parent_link_id}) — separate from the original.
            </p>
          )}
          <div className="flex flex-wrap gap-3">
            <button type="button" onClick={() => downloadDataUrl(`data:image/png;base64,${result.png_base64}`, "tracking-link-qr.png")} data-testid="qr-download-png"
              className="font-body text-xs uppercase tracking-[0.14em] text-terracotta hover:underline">Download PNG</button>
            <button type="button" onClick={() => downloadDataUrl(`data:image/svg+xml;utf8,${encodeURIComponent(result.svg)}`, "tracking-link-qr.svg")} data-testid="qr-download-svg"
              className="font-body text-xs uppercase tracking-[0.14em] text-terracotta hover:underline">Download SVG</button>
            <button type="button" onClick={() => copyToClipboard(result.qr_target_url, "QR link")} data-testid="qr-copy-link"
              className="font-body text-xs uppercase tracking-[0.14em] text-terracotta hover:underline">Copy QR Link</button>
          </div>
        </div>
      )}
    </div>
  );
}
